import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { Field as ReduxFormField } from 'redux-form';
import { Field as FinalFormField } from 'react-final-form';
import { noop } from 'lodash/fp';
import { GEOLOCATION_NAME } from 'components/searchAds/constants';
import GeoLocationControl from '../Control';

const DEFAULT_PLACEHOLDER = __('search.filters.location.placeholder');

export default function GeoLocationField({
  isReactFinalForm = false,
  clearable = true,
  component = GeoLocationControl,
  onChanged = noop,
  placeholder = DEFAULT_PLACEHOLDER,
  ...props
}) {
  const Field = isReactFinalForm ? FinalFormField : ReduxFormField;

  return (
    <Field
      name={GEOLOCATION_NAME}
      clearable={clearable}
      component={component}
      onChanged={onChanged}
      placeholder={placeholder}
      {...props}
    />
  );
}

GeoLocationField.propTypes = {
  isReactFinalForm: PropTypes.bool,
  clearable: PropTypes.bool,
  onChanged: PropTypes.func,
  placeholder: PropTypes.string,
  component: elementType,
};
